import { render, staticRenderFns } from "./CsvViewer.vue?vue&type=template&id=cc53dda2&scoped=true&"
import script from "./CsvViewer.vue?vue&type=script&lang=js&"
export * from "./CsvViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc53dda2",
  null
  
)

export default component.exports